import React from 'react';
import HighlightText from './HighlightText';
import CTAButton from './CTAButton';
import {FaArrowRight} from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';




const CodeBlocks = ({position, heading, subHeading, ctaBtn1, ctaBtn2, codeBlock, backgroundGradient, codeColor }) => {
  return (
    <div className={`flex ${position} my-20 justify-between gap-10 `}>
        
        {/* Section 1 */}
        <div className='lg:w-[50%] flex flex-col gap-8'>
            {heading}
            <div className='text-richblack-300 font-bold '>
                {subHeading}
            </div>

            <div className='flex gap-7 mt-7'>
                <CTAButton active={ctaBtn1.active} linkto={ctaBtn1.linkto}>
                    <div className='flex flex-row items-center gap-2'>
                        {ctaBtn1.btnText}
                        <FaArrowRight/>
                    </div>
                </CTAButton>
                <CTAButton active={ctaBtn2.active} linkto={ctaBtn2.linkto}>
                    {ctaBtn2.btnText}
                </CTAButton>
            </div>
        </div>


        {/* Section 2 */}
        <div className='h-fit code-border flex flex-row py-3 text-[10px] sm:text-sm leading-[18px] sm:leading-6 max-w-[600px] relative lg:w-[500px]'>
            {/* HW --> BG Gradient */}
            {backgroundGradient}

            <div className='text-center flex flex-col w-[10%] select-none text-richblack-400 font-inter font-bold'>
                <p>1</p>
                <p>2</p>
                <p>3</p>
                <p>4</p>
                <p>5</p>
                <p>6</p>
                <p>7</p>
                <p>8</p>
                <p>9</p>
                <p>10</p>
                <p>11</p>
            </div>

            <div className={`w-[90%] flex flex-col gap-2 font-bold font-mono ${codeColor} pr-1`}>
                <TypeAnimation
                    sequence={[codeBlock, 1000, ""]}
                    repeat={Infinity}
                    cursor={true}
                    omitDeletionAnimation={true}
                    style={
                        {
                            whiteSpace: "pre-line",
                            display: "block"
                        }
                    }
                />
            </div>


        </div>



    </div>
  )
}

export default CodeBlocks
